<template>
  <div class="home-portal">
    <section class="hero">
      <div class="hero-inner">
        <div class="hero-copy">
          <h1 class="hero-title">铁路购票服务</h1>
          <p class="hero-desc">
            查询车次、预订车票、管理订单与乘车人。输入行程后进入车票查询页查看余票与票价。
          </p>
<!--          <div class="hero-tags">-->
<!--            <Tag color="blue">官方演示风格</Tag>-->
<!--            <Tag>支持多端适配</Tag>-->
<!--          </div>-->
        </div>
        <Card class="search-card" :bordered="false">
          <template #title>
            <span class="card-title">车票查询</span>
          </template>
          <Form layout="vertical" class="quick-search-form">
            <Row :gutter="16" class="search-fields-row">
              <Col :xs="24" :sm="7">
                <FormItem label="出发地">
                  <Select
                    v-model:value="form.fromStation"
                    show-search
                    :options="stationOptions"
                    placeholder="请选择出发站"
                    :filter-option="filterStation"
                  />
                </FormItem>
              </Col>
              <Col :xs="24" :sm="2" class="swap-col">
                <!-- 与两侧 FormItem 共用 label 高度，保证图标与 Select 输入框同一基线 -->
                <FormItem class="swap-form-item">
                  <template #label>
                    <span class="swap-label-ghost" aria-hidden="true">出发地</span>
                  </template>
                  <div class="swap-trigger" @click="swapStation">
                    <RetweetOutlined class="swap-icon" />
                  </div>
                </FormItem>
              </Col>
              <Col :xs="24" :sm="7">
                <FormItem label="目的地">
                  <Select
                    v-model:value="form.toStation"
                    show-search
                    :options="stationOptions"
                    placeholder="请选择到达站"
                    :filter-option="filterStation"
                  />
                </FormItem>
              </Col>
              <Col :xs="24" :sm="8">
                <FormItem label="出发日期">
                  <DatePicker
                    v-model:value="form.departureDate"
                    style="width: 100%"
                    :allow-clear="false"
                    :disabled-date="disabledDate"
                  />
                </FormItem>
              </Col>
            </Row>
            <div class="search-actions">
              <Button type="primary" size="large" :loading="loading" @click="goTicketSearch">
                查询车票
              </Button>
            </div>
          </Form>
        </Card>
      </div>
    </section>

    <Row :gutter="[16, 16]" class="blocks">
      <Col :xs="24" :lg="16">
        <Card title="出行提示" :bordered="false" class="notice-card">
          <List size="small" :data-source="notices" bordered>
            <template #renderItem="{ item }">
              <List.Item>
                <span class="notice-dot" />
                {{ item }}
              </List.Item>
            </template>
          </List>
        </Card>
      </Col>
      <Col :xs="24" :lg="8">
        <Card title="常用入口" :bordered="false" class="links-card">
          <Space direction="vertical" style="width: 100%" size="middle">
            <RouterLink class="entry-link" to="/ticketSearch">车票查询</RouterLink>
            <RouterLink class="entry-link" to="/ticketList">车票订单</RouterLink>
<!--            <RouterLink class="entry-link" to="/personalTicket">本人车票</RouterLink>-->
            <RouterLink class="entry-link" to="/passenger">乘车人管理</RouterLink>
          </Space>
        </Card>
      </Col>
    </Row>
  </div>
</template>

<script setup>
import { reactive, ref, computed, onMounted } from 'vue'
import { useRouter } from 'vue-router'
import {
  Card,
  Form,
  FormItem,
  Select,
  DatePicker,
  Button,
  Row,
  Col,
  Tag,
  List,
  Space,
  message
} from 'ant-design-vue'
import dayjs from 'dayjs'
import { RetweetOutlined } from '@ant-design/icons-vue'
import { fetchStationAll } from '@/service'

const router = useRouter()
const loading = ref(false)
const stationRaw = ref([])

const form = reactive({
  fromStation: '北京',
  toStation: '上海',
  departureDate: dayjs().add(7, 'day')
})

const stationOptions = computed(() =>
  stationRaw.value.map((item) => ({
    label: item.name,
    value: item.name
  }))
)

const notices = [
  '请准确填写乘车人证件信息，以免影响进站乘车。',
  '未尽事宜以车站公告及铁路旅客运输规程为准。',
  '未完成支付的订单请在支付有效期内完成支付，逾期将自动取消。'
]

const disabledDate = (current) =>
  current &&
  (current < dayjs().startOf('day') || current > dayjs().add(14, 'day'))

const filterStation = (input, option) =>
  (option?.label ?? '').toLowerCase().includes(input.toLowerCase())

const swapStation = () => {
  const a = form.fromStation
  form.fromStation = form.toStation
  form.toStation = a
}

const goTicketSearch = () => {
  if (!form.fromStation || !form.toStation) {
    message.warning('请选择出发地与目的地')
    return
  }
  if (form.fromStation === form.toStation) {
    message.warning('出发地与目的地不能相同')
    return
  }
  loading.value = true
  router
    .push({
      path: '/ticketSearch',
      query: {
        fromStation: form.fromStation,
        toStation: form.toStation,
        departureDate: form.departureDate.format('YYYY-MM-DD'),
        autoSearch: '1'
      }
    })
    .finally(() => {
      loading.value = false
    })
}

onMounted(() => {
  fetchStationAll()
    .then((res) => {
      if (res.success && res.data?.length) {
        stationRaw.value = res.data
      }
    })
    .catch(() => {})
})
</script>

<style lang="scss" scoped>
.home-portal {
  max-width: 1180px;
  margin: 0 auto;
}

.hero {
  margin-bottom: 20px;
  padding: 28px 24px 32px;
  border-radius: 16px;
  background: linear-gradient(
    135deg,
    #e8f1ff 0%,
    #f0f6ff 40%,
    #ffffff 100%
  );
  border: 1px solid #d9e5f7;
  box-shadow: 0 12px 40px rgba(30, 64, 175, 0.08);
}

.hero-inner {
  display: flex;
  flex-direction: column;
  gap: 24px;
}

@media (min-width: 992px) {
  .hero-inner {
    flex-direction: row;
    align-items: stretch;
    gap: 32px;
  }

  .hero-copy {
    flex: 0 0 320px;
  }

  .search-card {
    flex: 1;
    min-width: 0;
  }
}

.hero-title {
  margin: 0 0 12px;
  font-size: 26px;
  font-weight: 700;
  color: #1e293b;
  letter-spacing: 0.02em;
}

.hero-desc {
  margin: 0 0 16px;
  line-height: 1.75;
  color: #475569;
  font-size: 14px;
}

.hero-tags {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

.search-card {
  border-radius: 14px;
  box-shadow: 0 8px 28px rgba(15, 23, 42, 0.06);
}

.card-title {
  font-weight: 600;
  font-size: 16px;
  color: #1e3a5f;
}

.quick-search-form {
  padding-top: 4px;
}

/* 与各列 FormItem 顶部对齐，不再用 flex-end 以免中间列偏低 */
.search-fields-row {
  align-items: flex-start;
}

.swap-col {
  flex-shrink: 0;
}

.swap-label-ghost {
  visibility: hidden;
  white-space: nowrap;
}

.swap-form-item :deep(.ant-form-item-label > label) {
  height: auto;
}

.swap-trigger {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  min-height: 32px;
  cursor: pointer;
}

.swap-icon {
  font-size: 20px;
  color: #1990ff;
  transition: color 0.2s, transform 0.2s;
}

.swap-trigger:hover .swap-icon {
  color: #1677ff;
  transform: rotate(180deg);
}

@media (max-width: 575px) {
  .swap-col {
    padding: 0 0 4px;
  }

  .swap-form-item :deep(.ant-form-item-label) {
    display: none;
  }

  .swap-trigger {
    min-height: 36px;
  }
}

.search-actions {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  margin-top: 8px;
}

.blocks {
  margin-top: 4px;
}

.notice-card,
.links-card {
  border-radius: 14px;
  border: 1px solid #e6edf8;
  min-height: 220px;
}

.notice-dot {
  display: inline-block;
  width: 6px;
  height: 6px;
  margin-right: 10px;
  border-radius: 50%;
  background: #1677ff;
  vertical-align: middle;
}

.entry-link {
  display: block;
  padding: 10px 14px;
  border-radius: 10px;
  background: #f4f8ff;
  color: #1459c9;
  font-weight: 500;
  transition: background 0.2s, color 0.2s;

  &:hover {
    background: #eaf2ff;
    color: #0d47c4;
  }
}
</style>
